export type GeoJson = {
  coordinates: number[]
  type: string
}

export type GeoPOI = {
  distance: number
  geo_location: GeoJson
  label: string
  type: string
}

type GeoLabels = {
  city: string
  country: string
  zone: string
}

export enum Amenities {
  alarm = 'alarm',
  barrier_access = 'barrier_access',
  barrier_friendly = 'barrier_friendly',
  concierge = 'concierge',
  door_armor = 'armored_door',
  elevator = 'elevator',
  fiber = 'fiber',
  fireplace = 'fireplace',
  gate_electric = 'gate_electric',
  home_automation = 'home_automation',
  hydromassage = 'hydromassage',
  interphone_video = 'interphone_video',
  shared_garden = 'shared_garden',
  shared_pool = 'shared_pool',
  tennis_court = 'tennis_court',
  tv_antenna = 'tv_antenna',
  tv_sat = 'tv_sat',
  wall_cabinet = 'wall_cabinet',
}

type ListingInventory = 'ibuyer' | 'oda' | null

type ListingSalesPipeline = 'direct' | 'brokered' | null

export type ListingTitle = {
  language: string
  title: string
}

export type ListingDescription = {
  language: string
  neighbourhood: string
  property: string
}

type ListingContacts = {
  address: string
  email: string
  name: string
  phone: string
}

type ListingEnergyRating = {
  system: string
  value: string
}

export type ListingFloor = {
  building: number
  entire: boolean
  shift: string
}

export type ListingSegment = {
  area: number
  label: string
  orientation: string
}

export type ListingMediaItem = {
  index: number
  is_primary: boolean
  meta: Record<string, unknown>
  url: string
}

export type Listing = {
  administrative_area_net: number
  administrative_area_raw: number
  administrative_area_registry: number
  administrative_cert_habitable: boolean
  administrative_class_registry: string
  administrative_energy_performance_index: number
  administrative_energy_rating: ListingEnergyRating
  administrative_state_deed: string
  amenities: string[]
  contacts: ListingContacts
  created_at: Date
  descriptions: ListingDescription[]
  geo_city: string
  geo_country: string
  geo_labels: GeoLabels
  geo_location: GeoJson
  geo_pois: GeoPOI[]
  geo_street: string
  geo_street_number: string | null
  geo_zip: string
  geo_zone: string | null
  id: string
  inventory: ListingInventory
  media_floorplans: ListingMediaItem[]
  media_furnishing_proposals: ListingMediaItem[]
  media_pictures: ListingMediaItem[]
  pricing_fees_condo_unit: string
  pricing_fees_condo_value: number
  pricing_furnishing_unit: string
  pricing_furnishing_value: number
  pricing_sell_unit: string
  pricing_sell_value: number
  property_belongs_condo: boolean
  property_date_construction: string | null
  property_date_renovation: string | null
  property_exposures: string[]
  property_feature_balcony: boolean
  property_feature_basement: boolean
  property_feature_box: boolean
  property_feature_concierge: boolean
  property_feature_elevator: boolean
  property_feature_garden: boolean
  property_feature_parking: boolean
  property_feature_pool: boolean
  property_feature_terrace: boolean
  property_floor_building: number
  property_floor_entrance: number
  property_floor_position: string
  property_floors: ListingFloor[]
  property_is_entire_building: boolean
  property_segments_recreative: ListingSegment[]
  property_windows_glazing: string | null
  property_rooms_bath: number
  property_system_heating: string
  property_segments_box: ListingSegment[]
  property_segments_balcony: ListingSegment[]
  property_rooms_bed: number
  url_tour_virtual: string | null
  property_system_cooling: string
  property_segments_garret: ListingSegment[]
  transaction_id: string | null
  property_segments_terrace: ListingSegment[]
  updated_at: Date
  property_segments_garden: ListingSegment[]
  property_state_maintenance: string
  property_state_furniture: string
  property_parking_spaces: number
  property_type: string
  property_type_kitchen: string | null
  property_rooms_living: number
  property_segments_basement: ListingSegment[]
  sales_pipeline: ListingSalesPipeline
  property_segments_pool: ListingSegment[]
  property_rooms_all: number
  property_views: string[]
  selling_unit_id: string | null
  titles: ListingTitle[]
}

export type Marker = {
  count: number
  geo_location: GeoJson
}
